import React from "react";
import Factory from "../classes/factory";

const FactoryContext = React.createContext(new Factory(null));

export default FactoryContext;
